import { SkyDialog, SkyText } from "@skypointcloud/skypoint-ui";
import ClockImage from "../icons/ClockImage";

interface ISessionTimeoutDialogFluent {
  open: boolean;
  countdown: number;
  onLogout: () => void;
  onContinue: () => void;
}

export const SessionTimeoutDialogFluent = (props: ISessionTimeoutDialogFluent) => {
  const { open, countdown, onLogout, onContinue } = props;

  return (
    <SkyDialog
      open={open}
      onOpenChange={() => {
        // Prevent closing - this is an alert dialog
      }}
      title="Session timeout"
      variant="modal"
      primaryAction={{
        label: "Continue",
        onClick: onContinue,
      }}
      secondaryAction={{
        label: "Logout",
        onClick: onLogout,
      }}
    >
      {/* Timer Widget */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        <div style={{ width: "30px", height: "30px", display: "flex", alignItems: "center" }}>
          <ClockImage />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "baseline",
            gap: "2px",
          }}
        >
          <span
            key={countdown}
            style={{ color: "#E5505A", fontSize: "28px", fontWeight: 500 }}
          >
            {countdown}
          </span>
          <SkyText>sec</SkyText>
        </div>
      </div>

      {/* Session Text */}
      <SkyText className="text-center text-sm leading-relaxed">
        The current session is about to expire. Would you like to continue the session?
      </SkyText>
    </SkyDialog>
  );
};
